import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FeedbackDialogComponent } from './feedback-dialog/feedback-dialog.component';
import { UserSessionService } from 'bna-angular-auth-client';
import { OrganizationService } from 'src/app/core/services/http/agency-mgmt/organization.service';
import { OnboardingStatusResult } from 'src/app/settings/models/onboarding-status';
import { SettingsService } from 'src/app/core/services/http/settings.service';
import { StepSharedService } from 'src/app/settings/components/onboarding/stepshared.service';
import { filter } from 'rxjs';
import { Router } from '@angular/router';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  sub: Subscription;
  @Output() navigateToJobPost = new EventEmitter<void>();
  isOpenEmailDrawer: boolean = false;
  emailNotificationCount = 0;
  isKeyAutomateEnabled = true;
  onboardingStatusResult: OnboardingStatusResult;
  isPaid: boolean;
  public dialogRef: MatDialogRef<FeedbackDialogComponent>;
  isEnableQrScanning: boolean = false;
  isenableKeyCardScan: boolean = false;
  constructor(
    private dialog: MatDialog,
    private userSessionService: UserSessionService,
    private organizationService: OrganizationService,
    private settingsService: SettingsService,
    private stepSharedService: StepSharedService,
    private router: Router
  ) {
    if (this.userSessionService.isAuthenticated()) {
      this.loadStartupSettings();
    }
    this.userSessionService.isAuthenticated$
      .pipe(filter((d) => d.isAuthenticated))
      .subscribe(() => {
        this.loadStartupSettings();
      });
  }

  ngOnInit(): void {
    this.stepshared();
  }
  getOnboardingStatus() {
    this.settingsService.getOnboardingStatus().subscribe((status) => {
      this.isPaid = status.isPaid;
    });
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }
  openFeedbackDialog(): void {
    this.dialogRef = this.dialog.open(FeedbackDialogComponent);
  }

  private loadStartupSettings() {
    this.organizationService.getStartupSettings().subscribe((settings) => {
      this.isKeyAutomateEnabled = settings?.isKeyAutomateEnabled;
    });
    this.getOnboardingStatus();

    this.settingsService.getGeneralSettings().subscribe((settings) => {
      this.isEnableQrScanning = settings?.enableQrScanning ?? true;
      this.isenableKeyCardScan = settings?.enableKeyCardScan ?? true
    });
  }

  stepshared() {
    this.stepSharedService.getData().subscribe((data: boolean) => {
      if (data == true) {
        this.getOnboardingStatus();
      }
    });
  }
  openScannerDrawer(){
    this.router.navigate(['key-cabinet/qr-scaner']);
  }
  openRfidScannerDrawer(){
    this.router.navigate(['key-cabinet/rfid-scaner']);
  }
}
